import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const GOAL_CATEGORIES = {
    GENERAL: 'General',
    CAREER: 'Career',
    HEALTH: 'Health & Fitness',
    RELATIONSHIPS: 'Relationships',
    LEARNING: 'Learning & Education',
    BUCKET_LIST: 'Bucket List'
};

const CreateGoalModal = ({ show, handleClose, onCreateGoal }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('GENERAL');
    const [targetDate, setTargetDate] = useState('');

    const handleSubmit = () => {
        const goalData = {
            title,
            description,
            category,
            target_date: targetDate || null
        };
        onCreateGoal(goalData);
        setTitle('');
        setDescription('');
        setCategory('GENERAL');
        setTargetDate('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create New Goal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Goal Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter goal title"
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter goal description"
                        />
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                >
                                    {Object.entries(GOAL_CATEGORIES).map(([key, name]) => (
                                        <option key={key} value={key}>{name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Target Date (Optional)</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={targetDate}
                                    onChange={(e) => setTargetDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="success" onClick={handleSubmit} disabled={!title.trim()}>
                    Create Goal
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateGoalModal;
